import { Box } from '@mui/material'

function ResponsiveDivider() {
  return (
    <Box
      sx={{
        marginTop: 3,
        marginBottom: 3,
        position: "relative",
        borderBottom: 1,
        borderColor: "text.primary",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
      <Box
        sx={{
          position: "absolute",
          left: 0,
          top: "50%",
          transform: 'translateY(-50%)',
          borderRadius: '50%',
          backgroundColor: 'text.primary',
          width: 9,
          height: 9
        }} />
      <Box
        sx={{
          position: "absolute",
          right: 0,
          top: "50%",
          transform: 'translateY(-50%)',
          borderRadius: '50%',
          backgroundColor: 'text.primary',
          width: 9,
          height: 9
        }} />
    </Box>
  );
}

export default ResponsiveDivider
